/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentMethodCategory = {
    GIFT_CARD: 'GIFT_CARD',
    FOOD_DELIVERY_SERVICE: 'FOOD_DELIVERY_SERVICE',
    UNCLASSIFIED: 'UNCLASSIFIED',
    LOYALTY_CASH_POINTS: 'LOYALTY_CASH_POINTS'
} as const;
export type PaymentMethodCategory = typeof PaymentMethodCategory[keyof typeof PaymentMethodCategory];


export function instanceOfPaymentMethodCategory(value: any): boolean {
    for (const key in PaymentMethodCategory) {
        if (Object.prototype.hasOwnProperty.call(PaymentMethodCategory, key)) {
            if (PaymentMethodCategory[key as keyof typeof PaymentMethodCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentMethodCategoryFromJSON(json: any): PaymentMethodCategory {
    return PaymentMethodCategoryFromJSONTyped(json, false);
}

export function PaymentMethodCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodCategory {
    return json as PaymentMethodCategory;
}

export function PaymentMethodCategoryToJSON(value?: PaymentMethodCategory | null): any {
    return value as any;
}

export function PaymentMethodCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentMethodCategory {
    return value as PaymentMethodCategory;
}

